module.exports = __webpack_public_path__ + "fonts/Poppins-Black.42cf9f08.ttf";